import {useState} from "react";
import {FiAlertCircle, FiEdit} from "react-icons/fi";
import {useSearchParams} from "react-router";

import DefaultLogo from "@/assets/images/integrations/default.png";
import {Icon} from "@/components/icon/Icon.tsx";
import {ButtonAction} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";
import {IntegrationListData} from "@/lib/types/integrations.ts";
import {getIntegrationModuleInfo} from "@/pages/integrations/integrations.types.ts";
import {IntegrationActionEdit} from "@/pages/integrations/list/integrationsActive/actions/IntegrationActionEdit.tsx";
import {IntegrationLogsModal} from "@/pages/integrations/log/IntegrationLogsModal.tsx";

interface IntegrationsActiveRowProps {
  integration: IntegrationListData;
  currentUser: AccountUser;
}

export const IntegrationsActiveRow = ({integration, currentUser}: IntegrationsActiveRowProps) => {
  const [queryParams, setQueryParams] = useSearchParams();

  const [showIntegrationActionEdit, setShowIntegrationActionEdit] = useState(false);
  const [showIntegrationActionLogs, setShowIntegrationActionLogs] = useState(false);

  const moduleInfo = getIntegrationModuleInfo(integration.module);

  return (
    <div className={"d-flex align-items-center gap-3"}>
      <img
        src={moduleInfo?.logo ?? DefaultLogo}
        alt={moduleInfo?.label ?? integration.module ?? ""}
        height={20}
        width={20}
        className={"pulse-border-radius-lg"}
      />
      <div className={"d-flex align-items-center gap-0"}>
        {integration.name}
        {integration.contact_groups.length < 1 && currentUser!.has_write_access && (
          <>
            <ButtonAction
              tooltip={"Integration has no Contact Group assigned. Click to Edit."}
              onClick={() => setShowIntegrationActionEdit(true)}
            >
              <Icon icon={FiEdit} />
            </ButtonAction>

            <IntegrationActionEdit
              integration={integration}
              show={showIntegrationActionEdit}
              setShow={setShowIntegrationActionEdit}
            />
          </>
        )}
        {integration.is_errored && (
          <ButtonAction
            tooltip={integration.errors[0]?.short_error ?? "Integration is disabled due to errors. Click to view logs."}
            onClick={() => setShowIntegrationActionLogs(true)}
            className="px-0"
          >
            <Icon icon={FiAlertCircle} className={"pulse-color-orange-500"} />
          </ButtonAction>
        )}

        <IntegrationLogsModal
          show={showIntegrationActionLogs}
          hide={() => {
            setShowIntegrationActionLogs(false);
            const params = new URLSearchParams(queryParams);
            params.delete("err");
            setQueryParams(params);
          }}
          integration={integration}
        />
      </div>
    </div>
  );
};
